import { hbs } from 'ember-cli-htmlbars';
export default hbs("<CardDropPage::Layout>\n  <CardDropPage::Header />\n\n  {{outlet}}\n\n  <Common::Footer @hideDiscord=\'true\' @hideSocials=\'true\' />\n</CardDropPage::Layout>")